import { useTranslation } from 'react-i18next'
import {
  CreateView,
  CreateViewHeader,
} from '~/components/refineUi/views/createView'
import { TenantForm } from './form'

export function TenantCreate() {
  const { t } = useTranslation()
  return (
    <CreateView>
      <CreateViewHeader title={t('tenantsPage.create.title')} />
      <TenantForm action="create" />
    </CreateView>
  )
}
